<template>
  <v-menu
    bottom
    open-on-click
    :open-on-hover="false"
    :close-on-content-click="false"
    v-model="menuOpened"
    :nudge-width="450"
    max-width="350"
    transition="scale-transition">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on"></slot>
    </template>
    <v-card>
      <v-card-text class="text--primary">
        <v-row dense>
          <v-col cols="12">
            <v-switch dense
                      class="pa-0 mt-2 mr-2"
                      label="Compra entregue"
                      color="primary"
                      :disabled="entregue || !hasRoleGestorEntrega"
                      v-model="entregue"
                      @change="onChangeEntrega"/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <px-date-picker v-if="hasRoleGestorEntrega"
                            dense
                            label="Prazo de entrega"
                            input-class="rounded-tag-small"
                            v-model="dataPrevisaoEntrega"
                            @change="onChangeDateEntrega"/>
            <div v-else>
              <span>
                Prazo de entrega: {{ dataPrevisaoEntrega | date }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { SituacaoEntregaCompra } from 'px-business-components';

export default {
  props: {
    hasRoleGestorEntrega: Boolean,
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      menuOpened: false,
      entregue: false,
      dataPrevisaoEntrega: null,
    };
  },
  methods: {
    onChangeEntrega() {
      this.$emit('change-entrega', this.item);
    },
    onChangeDateEntrega() {
      this.$emit('change-data-entrega', this.item, this.dataPrevisaoEntrega);
    },
  },
  watch: {
    dataPrevisaoEntrega(newValue, oldValue) {
      if (newValue === oldValue || !newValue) {
        return;
      }
      if (this.dataPrevisaoEntrega === this.item.dataPrevisaoEntrega) {
        return;
      }
      this.onChangeDateEntrega();
    },
  },
  created() {
    this.entregue = this.item.situacaoEntrega === SituacaoEntregaCompra.keys.ENTREGUE.key;
    this.dataPrevisaoEntrega = this.item.dataPrevisaoEntrega;
  },
};
</script>
